<tr [ngClass]="cssClassName">
  <td easEditorBookingItemInheritableTypeHeader [inheritableType]="item.metadataList.length === 0 ? 'empty' : inheritableType" i18n>
    Metadata
  </td>
  <td>
    @if (item.metadataList.length === 0) {
      <span class="text-muted" i18n>
      Not set
    </span>
    }
    @for (itemMetadata of item.metadataList; track itemMetadata; let metadataLast = $last) {
      {{ itemMetadata.name }} = {{ itemMetadata.value }}
      @if (!metadataLast) {
        ,
      }
    }
    <button mat-icon-button
      aria-label="Edit metadata"
      i18n-aria-label
      (click)="onEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </td>
  <td>
    @if (item.metadataList.length > 0) {
      <eas-editor-booking-item-inheritable-type-badge [inheritableType]="inheritableType">
      </eas-editor-booking-item-inheritable-type-badge>
    }
  </td>
</tr>
